import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { authAtom } from '_state';

import axios from 'axios';
import Cookies from 'js-cookie';

import AuthContext from './AuthContext';

export default function AuthProvider({ children }) {
  let navigate = useNavigate();

  const [auth, setAuth] = useRecoilState(authAtom);

  const removeLocalStorage = () => {
    localStorage.removeItem('user');
    setAuth(null);
  };

  const setLocalStorage = (data) => {
    localStorage.setItem('user', JSON.stringify(data));
  };

  let signin = async (userInfo, callback) => {
    const { userId, password } = userInfo;

    try {
      const { data } = await axios.get(`/api/login`, { params: { userid: userId, userpw: password } });
      if (data?.success) {
        setLocalStorage(data.userInfo);
        setAuth(data.userInfo);
        if (data.userInfo.scale === 'N') {
          alert('아직 승인이 되지 않아 일부메뉴만 이용 가능합니다. ');
        }
        navigate('/');
      }
    } catch (err) {
      if (callback) callback({ status: err.response.status, message: '로그인 실패' });
      navigate('/login');
    }
  };

  let signout = (callback) => {
    removeLocalStorage();
  };

  let checkAuth = async () => {
    const accessToken = Cookies.get('access_token');
    const refreshToken = Cookies.get('refresh_token');

    try {
      if (accessToken) {
        const { data } = await axios.post(
          `/api/auth/verify`,
          {},
          {
            headers: {
              Authorization: `Bearer ${accessToken}`
            }
          }
        );
        if (!data.success) {
          throw new Error('access_token 만료');
        }
        setLocalStorage(data.userInfo);
      } else if (refreshToken) {
        const { data } = await axios.post(
          `/api/auth/verifyRefreshToken`,
          {},
          {
            headers: {
              Authorization: `Bearer ${refreshToken}`
            }
          }
        );
        if (!data.success) {
          throw new Error('access_token 만료');
        }
        setLocalStorage(data.userInfo);
      } else {
        throw new Error('access_token 없음');
      }
    } catch (error) {
      // console.log(error);
      removeLocalStorage();
    }
  };

  let value = { user: auth, signin, signout, checkAuth };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
